import { SortDemos } from "..\\..\\..\\..\\content\\studio\\sort\\sortDemos";
import React from 'react';
export default {
  SortDemos,
  React
};